import { render } from "./picture.vue?vue&type=template&id=418f5b5b&scoped=true"
import script from "./picture.vue?vue&type=script&lang=js"
export * from "./picture.vue?vue&type=script&lang=js"

import "./picture.vue?vue&type=style&index=0&id=418f5b5b&scoped=true&lang=css"

import exportComponent from "D:\\Users\\User\\Documents\\_PROJECTS\\VUE.JS\\tulmash\\web_widgets\\calc_conveyor\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418f5b5b"]])

export default __exports__